import React from 'react';
import './pagination.css';

const Pagination = ({ totalItems, itemsPerPage, currentPage, onPageChange }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const getDisplayedPages = () => {
    if (totalPages <= 3) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const pages = [];
    pages.push(1);

    if (currentPage > 3) {
      pages.push('...');
    }

    const startPage = Math.max(2, currentPage - 1);
    const endPage = Math.min(totalPages - 1, currentPage + 1);
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    if (currentPage < totalPages - 2) {
      pages.push('...');
    }

    if (totalPages > 1) {
      pages.push(totalPages);
    }

    return pages;
  };

  const displayedPages = getDisplayedPages();

  return (
    <div className="pagination__container">
      {totalPages > 1 && (
        <>
          <button
            onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
            className={`pagination__arrow ${currentPage === 1 ? 'disabled' : ''}`}
            disabled={currentPage === 1}
          >
            {"<"}
          </button>

          {displayedPages.map((number, index) => (
            <span
              key={index}
              onClick={() => typeof number === 'number' && onPageChange(number)}
              className={`pagination__number ${currentPage === number ? 'active' : ''} ${typeof number !== 'number' ? 'dots' : ''}`}
            >
              {number}
            </span>
          ))}

          <button
            onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
            className={`pagination__arrow ${currentPage === totalPages ? 'disabled' : ''}`}
            disabled={currentPage === totalPages}
          >
            {">"}
          </button>
        </>
      )}
    </div>
  );
};

export default Pagination;
